// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Element from "./element.js"
import Option from "./option.js"
import OptionPosition from "./option-position.js"
import Team from "./team.js"

const modelClassData = {
  "attributes": {
    "anonymized": {
      "column": {
        "default": false,
        "name": "anonymized",
        "null": false,
        "type": "boolean"
      },
      "name": "anonymized",
      "selected_by_default": null,
      "translated": null
    },
    "file_content_type": {
      "column": null,
      "name": "file_content_type",
      "selected_by_default": null,
      "translated": null
    },
    "file_name": {
      "column": null,
      "name": "file_name",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "option_id": {
      "column": {
        "default": null,
        "name": "option_id",
        "null": true,
        "type": "uuid"
      },
      "name": "option_id",
      "selected_by_default": null,
      "translated": null
    },
    "text_content": {
      "column": {
        "default": null,
        "name": "text_content",
        "null": true,
        "type": "text"
      },
      "name": "text_content",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "dropped_option_position_position": {
      "column": null,
      "name": "dropped_option_position_position",
      "selected_by_default": false,
      "translated": null
    },
    "file_path": {
      "column": null,
      "name": "file_path",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Answer",
  "collectionKey": "answers",
  "collectionName": "answers",
  "i18nKey": "answer",
  "camelizedLower": "answer",
  "name": "Answer",
  "nameDasherized": "answer",
  "pluralName": "answers",
  "ransackable_associations": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "document_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "document_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "document_attachment"
    },
    {
      "className": "OptionPosition",
      "collectionName": "option_positions",
      "foreignKey": "dropped_on_option_position_id",
      "name": "dropped_on_option_position",
      "macro": "belongs_to",
      "resource_name": "OptionPosition",
      "through": null
    },
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "has_one",
      "resource_name": "Element",
      "through": "user_element"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Option",
      "collectionName": "options",
      "foreignKey": "option_id",
      "name": "option",
      "macro": "belongs_to",
      "resource_name": "Option",
      "through": null
    },
    {
      "className": "OptionPosition",
      "collectionName": "option_positions",
      "foreignKey": "option_position_id",
      "name": "option_position",
      "macro": "belongs_to",
      "resource_name": "OptionPosition",
      "through": null
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_id",
      "name": "step",
      "macro": "has_one",
      "resource_name": "Step",
      "through": "element"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "step"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "has_one",
      "resource_name": "Team",
      "through": "team_survey"
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_survey_id",
      "name": "team_survey",
      "macro": "has_one",
      "resource_name": "TeamSurvey",
      "through": "user_element"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "UserElement",
      "collectionName": "user_elements",
      "foreignKey": "user_element_id",
      "name": "user_element",
      "macro": "belongs_to",
      "resource_name": "UserElement",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "anonymized",
      "column": {
        "default": false,
        "name": "anonymized",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "dropped_on_option_position_id",
      "column": {
        "default": null,
        "name": "dropped_on_option_position_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_option_id",
      "column": {
        "default": null,
        "name": "old_option_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_user_element_id",
      "column": {
        "default": null,
        "name": "old_user_element_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "option_id",
      "column": {
        "default": null,
        "name": "option_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "option_position_id",
      "column": {
        "default": null,
        "name": "option_position_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "text_content",
      "column": {
        "default": null,
        "name": "text_content",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_element_id",
      "column": {
        "default": null,
        "name": "user_element_id",
        "null": false,
        "type": "uuid"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "has_one",
      "resource_name": "Element",
      "through": "user_element"
    },
    {
      "className": "Option",
      "collectionName": "options",
      "foreignKey": "option_id",
      "name": "option",
      "macro": "belongs_to",
      "resource_name": "Option",
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "has_one",
      "resource_name": "Team",
      "through": "team_survey"
    },
    {
      "className": "OptionPosition",
      "collectionName": "option_positions",
      "foreignKey": "option_position_id",
      "name": "option_position",
      "macro": "belongs_to",
      "resource_name": "OptionPosition",
      "through": null
    }
  ],
  "paramKey": "answer",
  "primaryKey": "id"
}

/** Frontend model for Answer. */
export default class Answer extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  anonymized() {
    return this.readAttributeUnderscore("anonymized")
  }

  /** @returns {boolean} */
  hasAnonymized() {
    const value = this.anonymized()

    return this._isPresent(value)
  }

  /** @returns {any} */
  fileContentType() {
    return this.readAttributeUnderscore("file_content_type")
  }

  /** @returns {boolean} */
  hasFileContentType() {
    const value = this.fileContentType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  fileName() {
    return this.readAttributeUnderscore("file_name")
  }

  /** @returns {boolean} */
  hasFileName() {
    const value = this.fileName()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  optionId() {
    return this.readAttributeUnderscore("option_id")
  }

  /** @returns {boolean} */
  hasOptionId() {
    const value = this.optionId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  textContent() {
    return this.readAttributeUnderscore("text_content")
  }

  /** @returns {boolean} */
  hasTextContent() {
    const value = this.textContent()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  droppedOptionPositionPosition() {
    return this.readAttributeUnderscore("dropped_option_position_position")
  }

  /** @returns {boolean} */
  hasDroppedOptionPositionPosition() {
    const value = this.droppedOptionPositionPosition()

    return this._isPresent(value)
  }

  /** @returns {any} */
  filePath() {
    return this.readAttributeUnderscore("file_path")
  }

  /** @returns {boolean} */
  hasFilePath() {
    const value = this.filePath()

    return this._isPresent(value)
  }

  /** @returns {import("./element.js").default | null} */
  element() {
    return this._readHasOneReflection({modelClass: Element, reflectionName: "element"})
  }

  /** @returns {Promise<import("./element.js").default | null>} */
  loadElement() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "element",
        model: this,
        modelClass: Element
      },
      {
        params: {
          through: {
            model: "Answer",
            id,
            reflection: "element"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./element.js").default | null>} */
  ensureElementLoaded() {
    return this.ensureAssociationLoaded("element")
  }

  /** @returns {import("./option.js").default | null} */
  option() {
    return this._readBelongsToReflection({modelClass: Option, reflectionName: "option"})
  }

  /** @returns {Promise<import("./option.js").default | null>} */
  loadOption() {
    if (!("optionId" in this)) throw new Error("Foreign key method wasn't defined: optionId")

    const id = this.optionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "option",
        model: this,
        modelClass: Option
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./option.js").default | null>} */
  ensureOptionLoaded() {
    return this.ensureAssociationLoaded("option")
  }

  /** @returns {import("./team.js").default | null} */
  team() {
    return this._readHasOneReflection({modelClass: Team, reflectionName: "team"})
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  loadTeam() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "team",
        model: this,
        modelClass: Team
      },
      {
        params: {
          through: {
            model: "Answer",
            id,
            reflection: "team"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  ensureTeamLoaded() {
    return this.ensureAssociationLoaded("team")
  }

  /** @returns {import("./option-position.js").default | null} */
  optionPosition() {
    return this._readBelongsToReflection({modelClass: OptionPosition, reflectionName: "option_position"})
  }

  /** @returns {Promise<import("./option-position.js").default | null>} */
  loadOptionPosition() {
    if (!("optionPositionId" in this)) throw new Error("Foreign key method wasn't defined: optionPositionId")

    const id = this.optionPositionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "option_position",
        model: this,
        modelClass: OptionPosition
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./option-position.js").default | null>} */
  ensureOptionPositionLoaded() {
    return this.ensureAssociationLoaded("option_position")
  }
}
